import { Locale } from 'scoped-translations';

export const DEFAULT_MAX_FILE_SIZE_BYTE = 5_000_000; // 5 Mo
export const DEFAULT_MAX_PDF_SIZE_BYTE = 12_000_000; // 12 Mo
export const DEFAULT_MAX_VIDEO_SIZE_BYTE = 100_000_000; // 100 Mo

export const LOCALE_FR: Locale = 'fr-FR';

export const FORM_FIELD_MAX_LENGTH = '400px';

export const BACKEND_URL = '/backend/api/v1';

export const BACKEND_URL_KOALA = '/backend-phenix';
